export default "__VITE_ASSET__DIKx6o0G__"